import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {map} from 'rxjs';
import {
  PersonalManager,
  PersonalManagerRatingAnswer,
  PersonalManagerRatingQuestion,
  PersonalManagerRatingQuestionNormalized,
} from '../models/personal-manager.model';
import {ConfigService} from '../../../../services/config.service';
import {NoRestApiHelper} from '../../../../services/no-rest-api.helper';

@Injectable({
  providedIn: 'root'
})
export class PersonalManagerService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private noRestApiHelper: NoRestApiHelper,
  ) {
  }

  getPersonalManager(ref: string): Observable<PersonalManager> {
    const body = {
      system: this.configService.get('system'),
      modelName: 'Common',
      calledMethod: 'getPersonalManager',
      methodProperties: {
        Ref: ref,
      },
    };

    return this.http.post(`${this.configService.get('apiUrl')}json/`, body)
      .pipe(
        map(data => this.noRestApiHelper.checkErrors({data})),
        map(response => response.data.data[0] as PersonalManager),
      );
  }

  getPersonalManagerRatingQuestions(): Observable<PersonalManagerRatingQuestionNormalized[]> {
    const body = {
      system: this.configService.get('system'),
      modelName: 'Common',
      calledMethod: 'getReviewTypes',
      methodProperties: {
        DeliveryTo: 'Manager',
        Language: 'ua',
      },
    };

    return this.http.post<PersonalManagerRatingQuestion>(`${this.configService.get('apiUrl')}json/`, body)
      .pipe(
        map(data => this.noRestApiHelper.checkErrors({data})),
        map(response => response.data.data),
        map((data: PersonalManagerRatingQuestion[]) => data.map((el, index) => ({
          ...el,
          filled: false,
          disabled: true,
          number: index + 1,
        })) as PersonalManagerRatingQuestionNormalized[]),
      );
  }

  sendPersonalManagerRatingAnswers(counterpartyRef: string,
                                   managerRef: string,
                                   answers: PersonalManagerRatingAnswer[]): Observable<any> {
    const body = {
      modelName: 'Common',
      calledMethod: 'sendPollAnswer',
      methodProperties: {
        CounterpartyRef: counterpartyRef,
        ManagerRef: managerRef,
        Status: '1',
        Mark: '5',
        Comment: '',
        DeliveryTo: 'Manager',
        TypesReview: answers,
      },
    };

    return this.http.post(`${this.configService.get('apiUrl')}json/`, body)
      .pipe(
        map(data => this.noRestApiHelper.checkErrors({data})),
        map(response => response.data),
      );
  }
}
